module.exports = __webpack_public_path__ + "assets/fileUpload.0e58ce221b0e6b26a682fb4213ae67de.png";